import { queryOptions } from '@tanstack/react-query';

import downloadTextFileFromDatalake from '@/shared/lib/download/downloadTextFileFromDatalake';

export const feedArticleOptions = {
  file: (groupName: string, fileName: string, open: boolean) =>
    queryOptions({
      queryKey: ['datalake', 'file', groupName, fileName] as const,
      queryFn: () => downloadTextFileFromDatalake(fileName, groupName),
      enabled: open,
      retry: false,
      refetchOnWindowFocus: false
    })
};
